import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "support" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_support_content = _resolveComponent("support-content")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      class: "back-button",
      to: {name: "auth"}
    }, {
      default: _withCtx(() => [
        _cache[0] || (_cache[0] = _createElementVNode("i", { class: "icons8-back" }, null, -1)),
        _createTextVNode(_toDisplayString(_ctx.$t('SUPPORT.BACK_TO_LOGIN')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_support_content, { class: "mt-4" })
  ]))
}